import { Controller, useFormContext } from 'react-hook-form'

import { CheckBox, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const NoRelationship = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control, setValue } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.noRelationship`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          errorPosition="right"
          input={(props) => (
            <CheckBox
              {...props}
              checkBoxLabel="j. No relationship to institution"
              onChange={(value) => {
                if (value) {
                  setValue(`subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.accountant`, false)
                  setValue(`subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.agent`, false)
                  setValue(`subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.appraiser`, false)
                  setValue(`subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.attorney`, false)
                  setValue(`subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.borrower`, false)
                  setValue(`subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.customer`, false)
                  setValue(`subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.director`, false)
                  setValue(`subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.employee`, false)
                  setValue(`subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.officer`, false)
                  setValue(`subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.owner`, false)
                  setValue(`subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.other`, false)
                  setValue(`subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.otherDesc`, '')
                  setValue(`subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.relationshipStatus`, '')
                }

                field.onChange(value)
              }}
            />
          )}
        />
      )}
    />
  )
}
